import { Component, inject } from '@angular/core';
import { ActionResult, ItemViewProviderDirective } from '@ntap/core';
import { ConfirmationService } from 'primeng/api';
import { EMPTY, map, Observable, Subject, switchMap } from 'rxjs';
import { PrimeNGButtonActionComponent } from '@ntap/primeng';

@Component({
  selector: 'app-ukloni-rok-cuvanja-na-jedinicama',
  templateUrl: '../../../shared/components/actions/common-action-template.html'
})
export class UkloniRokCuvanjaActionComponent extends PrimeNGButtonActionComponent {
  private itemViewProvider = inject(ItemViewProviderDirective);
  private confirmationService = inject(ConfirmationService);

  protected override initDisabledObservable(): void {
    super.initDisabledObservable();
    this.isDisabled$ = this.itemProvider.item$.pipe(
      map((item) => (item as any)['sv~rok_cuvanja~id'] === 0)
    );
  }

  protected override doExecute(): Observable<ActionResult> {
    const accepted$ = new Subject<boolean>();

    this.confirmationService.confirm({
      message:
        'Jeste li sigurni da želite ukloniti rok čuvanja na trenutnoj jedinici i na podjedinice ako je primijenjen?',
      accept: () => {
        accepted$.next(true);
        accepted$.complete();
        accepted$.unsubscribe();
        this.changeViewMetadata(true, false, -1);
        this.itemViewProvider.reload();
      },
      reject: () => {
        accepted$.next(false);
        accepted$.complete();
        accepted$.unsubscribe();
      }
    });
    return accepted$.pipe(
      switchMap((e) => {
        if (e) {
          return super.doExecute();
        }
        return EMPTY;
      })
    );
  }

  changeViewMetadata(clearKlasa: boolean, klasaSet: boolean, klasaId: number) {
    const viewname = this.itemViewProvider.viewName;
    const viewstate: any = this.itemViewProvider.viewState;
    viewstate['$clearKlasa'] = clearKlasa;
    viewstate['$klasaSet'] = klasaSet;
    viewstate['$klasaId'] = klasaId;
    // this.itemViewProvider.viewName = '';
    // this.itemViewProvider.viewState = {};
    this.itemViewProvider.viewName = viewname;
    this.itemViewProvider.viewState = viewstate;
  }
}
